import type { Transition, Variants } from "motion/react";

export const CONVERSATION_SWITCH_DURATION_S = 0.18;
export const CONVERSATION_SWITCH_OFFSET_PX = 10;

export function conversationSwitchMotion(options: {
  isRtl: boolean;
  reduceMotion: boolean;
}): { variants: Variants; transition: Transition } {
  if (options.reduceMotion) {
    return {
      variants: {
        initial: { opacity: 0 },
        animate: { opacity: 1, pointerEvents: "auto" },
        exit: { opacity: 0, pointerEvents: "none" },
      },
      transition: { duration: 0 },
    };
  }

  const enterX = options.isRtl ? -CONVERSATION_SWITCH_OFFSET_PX : CONVERSATION_SWITCH_OFFSET_PX;
  const exitX = options.isRtl ? CONVERSATION_SWITCH_OFFSET_PX : -CONVERSATION_SWITCH_OFFSET_PX;

  return {
    variants: {
      initial: { opacity: 0, x: enterX },
      animate: { opacity: 1, x: 0, pointerEvents: "auto" },
      exit: { opacity: 0, x: exitX, pointerEvents: "none" },
    },
    transition: {
      duration: CONVERSATION_SWITCH_DURATION_S,
      ease: [0.22, 1, 0.36, 1],
    },
  };
}
